/**
 * @description - definitions for analytic events. Emphasis is placed on having generic tracking events.
 * Do not create more unnecessarily. See link below for more information.
 * {@linkplain https://docs.google.com/spreadsheets/d/1sjXP0HLhOKvSfUjb25-CFY9bSFCCbkJ_2rJirTika_A/edit?usp=sharing
 */

const PREFIX = 'Analytics_ClickStreamTracker_Event --';

export const ANALYTICS = {
  TEAM: 'special-projects',
  PROJECT: 'chat-ui',
  SESSION_ID: 'session_id',
  EVENT: {
    CHAT_OPENED: `${PREFIX} chat_opened`,
    CHAT_CLOSED: `${PREFIX} chat_closed`,
    CHAT_RECONNECTED: `${PREFIX} inactivity_reconnected`,
    CONVERSATION_STARTED: `${PREFIX} conversation_started`,
    CLICKED: `${PREFIX} clicked`,
    CLICKED_LINK: `${PREFIX} clicked_link`,
    ERROR_MESSAGE_SHOWN: `${PREFIX} error_message_shown`,
    INACTIVITY_SHOWN: `${PREFIX} inactivity_shown`,
    FORM_FAILED: `${PREFIX} form_failed`,
    FORM_SUBMITTED: `${PREFIX} form_submitted`,
    QUICK_REPLY: `${PREFIX} quick_reply`,
    SCROLL_ARROW_SHOWN: `${PREFIX} scroll_arrow_shown`,
    TOAST_SHOWN: `${PREFIX} toast_shown`,
    TIME_ELAPSED: `${PREFIX} time elapsed`,
    VIEW_DISPLAYED: `${PREFIX} view`,
  },
};
